import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id A671C11E-0A75-4F41-AA32-EAA99955DEDE
 * name school
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/school.svg
 * tags
 */
export const SchoolIcon = createSvgIcon(<><path d="M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z" /></>, 'SchoolIcon');
export default SchoolIcon